var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 264.58 264.58",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.66184,
    y: -0.62964,
    width: 265.33,
    height: 267.36,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m152.16 26.464 13.966-12.217v231.65h-13.926z",
    fill: "#322ca0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.99 31.404 8.863 8.1403v206.02h-8.7874z",
    fill: "#322ca0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.776 15.951 173.19 46.405-0.74498 8.373-178.81-47.912v-5.725z",
    fill: "#322ca0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.29 51v27.025l24.282 6.5074 8.9088-5.1443v-26.303l-24.5-6.5659z",
    fill: "#322ca0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.397 133.53 49.656-92.172-42.839 87.807s-2.6421 1.637-6.817 4.3648z",
    fill: "#3f37c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.71 133.53-49.656-92.172 42.839 87.807s2.6421 1.637 6.817 4.3648z",
    fill: "#322ca0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.075 250.34h202.43l-22.625-6.9336h-159.48z",
    fill: "#322ca0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.058 233.93c33.889-15.79 44.538-30.015 49.569-96.883-17.188-10.551-33.692-17.922-49.347-21.339-18.833 5.4205-34.991 12.664-49.726 20.877 2.8691 75.5 26.986 83.897 49.504 97.345z",
    fill: "#322ca0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.058 233.93 0.22242-118.22c-18.833 5.4205-34.991 12.664-49.726 20.877 2.8691 75.5 26.986 83.897 49.504 97.345z",
    fill: "#3f37c9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c43ce4b99ef6bae764b92615c2083856.svg";
export { ForwardRef as ReactComponent };